__webpack_require__.p = "/investment/funds/";